import axios from 'axios';
import querystring from 'querystring';
export const UPDATE_TICKER_TO_COMPARE = 'update_ticker_to_compare';
export const LOAD_TYPEAHEAD = 'load_typeahead';
export const SET_PARAMS = 'set_params';
export const ANALYZE_FUNDS = 'analyze_funds';
export const CLEAR_FUNDS = 'clear_funds';
export const CLEAR_FUND = 'clear_fund';
export const SHOW_OR_HIDE_WT_FUNDS = 'show_or_hide_wt_funds';
export const SHOW_CAPGAINS_OR_PERF = 'show_capgains_or_perf';
export const CHECK_TICKERS = 'check_tickers';
export const UPDATE_SELECTED_FUNDS = 'update_selected_funds';
export const UPDATE_SELECTED_FUNDS_EXCEL = 'update_selected_funds_excel';
export const CLEAR_SELECTED_FUNDS = 'clear_selected_funds';
export const OPEN_EXTERNAL_LINK_MODAL = 'open_external_link_modal';
export const CLOSE_EXTERNAL_LINK_MODAL = 'close_external_link_modal';
export const LOAD_PORTFOLIO = 'load_portfolio_from_history';

export function setParams(param) {
  return (dispatch, getState) => {
    dispatch({ type: SET_PARAMS, payload: param });
  };
}

export function submitFundsToAnalyze(fundsToAnalyze) {
  return (dispatch, getState) => {

    var params = getState().params;

    dispatch({ type: ANALYZE_FUNDS, payload: 'Loading Capital Gains analysis...' });

    // Update the table back to Cap Gains
    dispatch({ type: SHOW_CAPGAINS_OR_PERF, payload: 'capgains' });

    const url = params.dataspanApiUrl + 'capgains/';

    // Map the value field (that contains external ID from the select box) into an externalIDs array
    const externalIDs = fundsToAnalyze.map(a => a.value);

    // Get the Mapping of input funds to WT Funds with Cap Gains information
    return axios.post(
      url,
      {
        clientEmail: params.clientEmail,
        wtRegion: params.wtRegion,
        externalIDs: externalIDs

      })
      .then(response => {

        if (response.data.results !== undefined) {

          dispatch({ type: ANALYZE_FUNDS, payload: response.data.results });
          saveToSalesforce(params, response.data.results);

        }


      })
      .catch(error => {
        console.log(error);
      });

  };
}

let counter = 0; // see explanation of requestIndex below
export function typeahead(query, params) {

  return (dispatch, getState) => {

    // requestIndex encodes the order at which queries are sent to the server in order
    // to ensure that a long-running query, whose response arrives after a more recent
    // and relevant query has completed, doesn't override the latest query results
    const requestIndex = counter++;

    if (!query || query.length <= 1) {
      return dispatch({ type: LOAD_TYPEAHEAD, requestIndex, query, payload: [] });
    }

    const url = `${process.env.REACT_APP_DPD_URL}/api/securityfund/typeahead/`;

    fetch(url + '?q=' + query + '&wtRegion=' + params.wtRegion + '&excludeCS')
      .then(d => d.json())
      .then(data => {
        // console.log(data);
        dispatch({
          type: LOAD_TYPEAHEAD,
          requestIndex, query,
          payload: Array.isArray(data) ? data : [],
        });
      })
      .catch(error => {
        console.error(error);
        dispatch({ type: LOAD_TYPEAHEAD, requestIndex, query, payload: [] });
      });
  };

}

// Clear the fund list
export function clearFunds() {

  return (dispatch) => {
    dispatch({ type: CLEAR_FUNDS });
  };

}

// Clear a fund from the results set given an index value
export function clearFund(externalID) {

  return (dispatch) => {
    dispatch({ type: CLEAR_FUND, payload: externalID });
  };

}

// Passes on a bool to show or hide the wt funds
export function showOrHideWTFunds(show) {

  return (dispatch) => {
    dispatch({ type: SHOW_OR_HIDE_WT_FUNDS, payload: show });
  };

}

// Update the selection from the dropdown
export function updateSelectedFunds(selectedFunds) {

  return (dispatch) => {
    dispatch({ type: UPDATE_SELECTED_FUNDS, payload: selectedFunds });
  };

}

// Clear all the funds from the selection
export function clearSelectedFunds() {

  return (dispatch) => {
    dispatch({ type: CLEAR_SELECTED_FUNDS });
  };

}

// Choose whether to show Capital Gains or Performance table
export function showCapGainsOrPerformance(type) {

  return (dispatch) => {

    dispatch({ type: SHOW_CAPGAINS_OR_PERF, payload: type });
  };

}

// Load the tickers from the Excel file provided
export function checkTickers(tickers, params) {

  return (dispatch, getState) => {

    // Add promise to this method can be used on load to automatically perform the analysis
    return new Promise((resolve, reject) => {

      const url = params.dataspanApiUrl + "capgains/ticker_names/";

      fetch(url, {
        method: 'POST',
        body: JSON.stringify({ tickers }),
        headers: {
          'Content-Type': 'application/json'
        },
      })
        .then(d => d.json())
        .then(data => {

          let results = [];

          // Check for unknown funds, and only push those that are found
          data.forEach((fund) => {
            if (fund.name !== 'UNKNOWN') {
              results.push(fund);
            }
          });
          // console.log('results: ' + results);

          dispatch({
            type: UPDATE_SELECTED_FUNDS_EXCEL,
            payload: Array.isArray(results) ? results : null,
          });

          resolve();

        })
        .catch(error => {
          console.error(error);
          reject();
        });
      });
  };

}

// Pass URL of external link to show
export function openExternalLinkModal(url) {

  return (dispatch) => {
    dispatch({ type: OPEN_EXTERNAL_LINK_MODAL, payload: url });
  };

}

// Close action for Modal
export function closeExternalLinkModal() {

  return (dispatch) => {
    dispatch({ type: CLOSE_EXTERNAL_LINK_MODAL });
  };

}

// Save the run of loaded funds to Salesforce
export function saveToSalesforce(params, fundData) {

  // Don't do anything if not FP (or if we don't have a token) as we don't have token or any
  // client data
  if (!params.token) {
    console.log('Missing token - do not save to sfdc');
    return null;
  }

  // Set up the url endpoint
  const url = `${process.env.REACT_APP_API_URL}sfdc/activity/`;

  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    Authorization: params.token &&
      `Token ${params.token}`,
  };

  // Set up the fund description data
  const description = fundData.map((result) => `${result.inputFund.ticker} (${result.inputFund.name})\n`).toString().replace(/,/g, '');

  // Get tickers for the header
  const heading = fundData.map((result) => `${result.inputFund.ticker}`).toString();

  // Set up the data to post for the activity
  const data = {
    clientEmail: params.clientEmail,
    activityType: `DPD_CapitalGainsComparison`,
    description: `Funds compared: \n\n ${description}`,
    subject: `${heading}`,
  };

  const request = {
    method: 'POST',
    url: url,
    headers: headers,
    data: querystring.stringify(data),
  };
  return axios(request)
    .then((response) => {
      console.debug(response.data);
    })
    .catch((error) => {
      console.log(error);
    });
}





// WEBPACK FOOTER //
// ./src/actions/actions.js